exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".nj9CDfOahI6GOfpmn5zDP{width:100%}._27sU7_Qo5tK5UeKmzpTD9H{width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;font-size:20px;font-family:inherit;border:none;border-radius:5px;background-color:#eee;padding:10px}._27sU7_Qo5tK5UeKmzpTD9H:focus{outline:none}", "", {"version":3,"sources":["/home/runner/work/frontend/frontend/src/App/Pages/Auth/Text/styles.css"],"names":[],"mappings":"AAAA,uBACE,UAAY,CACb,AAED,yBACE,WAAY,AACZ,8BAA+B,AACvB,sBAAuB,AAC/B,eAAgB,AAChB,oBAAqB,AACrB,YAAa,AACb,kBAAmB,AACnB,sBAAuB,AACvB,YAAc,CACf,AAED,+BACE,YAAc,CACf","file":"styles.css","sourcesContent":[":local(.container) {\n  width: 100%;\n}\n\n:local(.input) {\n  width: 100%;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  font-size: 20px;\n  font-family: inherit;\n  border: none;\n  border-radius: 5px;\n  background-color: #eee;\n  padding: 10px;\n}\n\n:local(.input):focus {\n  outline: none;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "nj9CDfOahI6GOfpmn5zDP",
	"input": "_27sU7_Qo5tK5UeKmzpTD9H"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/App/Pages/Auth/Text/styles.css
// module id = 2024
// module chunks = 22 39 50 51 52